// Ensure Angular's dev mode globals exist even when optimized builds strip them.
// This guards against runtime ReferenceError: ngDevMode is not defined when some libs
// accidentally reference these flags. Safe no-ops in both dev and prod.

type NgGlobals = {
    ngDevMode?: boolean;
    ngJitMode?: boolean;
    ngProbe?: (...args: unknown[]) => unknown;
};

const g = globalThis as typeof globalThis & NgGlobals;

if (typeof g.ngDevMode === 'undefined') {
    g.ngDevMode = false;
}

if (typeof g.ngJitMode === 'undefined') {
    g.ngJitMode = false;
}

if (typeof g.ngProbe === 'undefined') {
    // Provide a typed no-op function
    g.ngProbe = () => undefined;
}
